export const USER_ADD = 'USER_ADD'
export const USER_DEL = 'USER_DEL'
export const USER_POST = 'USER_POST'
export const USERS_FETCH = 'USERS_FETCH'
export const API = 'API'
